/** Filter questions by `condition` and repeat-form rules. */
export const filterQuestions = (allQs, formData, user) => {
  const isRepeat = user.returning;
  return allQs.filter((q) => {
    const cond =
      typeof q.condition === "function"
        ? q.condition.length === 1
          ? q.condition(formData)
          : q.condition(formData, user)
        : true;
    return isRepeat ? cond && q.repeatable : cond;
  });
};

/** Convert a flat list into `{ type:'single'|'group', … }` steps. */
export const buildSteps = (filteredQs) => {
  const steps = [];
  for (let i = 0; i < filteredQs.length; ) {
    const q = filteredQs[i];
    if (q.group) {
      const group = [q];
      let j = i + 1;
      while (j < filteredQs.length && filteredQs[j].group === q.group) {
        group.push(filteredQs[j++]);
      }
      steps.push({ type: "group", questions: group });
      i = j;
    } else {
      steps.push({ type: "single", question: q });
      i++;
    }
  }
  steps.push({ type: "review" });
  return steps;
};

/** Defaults for range sliders the user hasn’t touched yet. */
export const rangeDefaults = (questions, formData) =>
  questions.reduce((acc, q) => {
    if (
      q.fieldType === "range" &&
      (formData[q.id] == null || formData[q.id] === "")
    ) {
      acc[q.id] = q.min;
    }
    return acc;
  }, {});

/** Persist small localStorage blobs and navigate. */
export const persistAndGotoGuide = (filtered, data, nav) => {
  const autoFill = {};
  filtered.forEach((q) => {
    if (q.autoFillLocal) autoFill[q.id] = data[q.id];
  });
  localStorage.setItem("autoFillData", JSON.stringify(autoFill));
  localStorage.setItem("formMetadata", JSON.stringify(data));
  nav("/guide");
};
